import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { mockDocuments } from '../data/mockData';
import '../styles/ListPage.css';

const ListPage: React.FC = () => {
  const { t } = useLanguage();

  const isBothSigned = (doc: any) => {
    return doc.issuedByStatus === 'signed' && doc.issuedToStatus === 'signed';
  };

  const handleDownload = (fileName: string, e: React.MouseEvent) => {
    e.stopPropagation();

    // Создаём фиктивную ссылку для скачивания
    const link = document.createElement('a');
    link.href = '#'; // В реальном приложении здесь будет URL файла с сервера
    link.download = fileName;

    // Для демонстрации - показываем уведомление
    alert(`Скачивание файла: ${fileName}\n\nВ реальном приложении здесь будет загрузка файла с сервера.`);

    // В реальном приложении:
    // link.href = `/api/documents/download/${documentId}`;
    // document.body.appendChild(link);
    // link.click();
    // document.body.removeChild(link);
  };

  return (
    <div className="list-page">
      <div className="documents-grid">
        {mockDocuments.map((doc) => (
          <div key={doc.id} className={`document-card ${isBothSigned(doc) ? 'both-signed' : ''}`}>
            <div className="document-date-badge">{doc.date}</div>
            <div className="document-main">
              <div className="document-header">
                <div className="document-participants">
                  <div className={`participant-block status-${doc.issuedByStatus}`}>
                    <div className="participant-name">{doc.issuedBy}</div>
                    <div className="participant-tin">ИНН: {doc.issuedByTin}</div>
                  </div>
                  <div className="arrow-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <path d="M5 12h14m-7-7l7 7-7 7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                  <div className={`participant-block status-${doc.issuedToStatus}`}>
                    <div className="participant-name">{doc.issuedTo}</div>
                    <div className="participant-tin">ИНН: {doc.issuedToTin}</div>
                  </div>
                </div>
              </div>
              <div className="document-footer">
                <div className="document-file">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                    <path d="M13 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V9z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M13 2v7h7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  <span className="file-name">{doc.fileName}</span>
                  <button
                    className="download-button-inline"
                    onClick={(e) => handleDownload(doc.fileName, e)}
                    title="Скачать документ"
                  >
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M7 10l5 5 5-5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M12 15V3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ListPage;
